<ion-app>
  <app-offline-bubble></app-offline-bubble>

  <div class="app-bootstrap-screen" *ngIf="isBootstrapping">
    <div class="app-bootstrap-mark">
      <div class="app-bootstrap-ring"></div>
      <img src="assets/logo/client/icon_192x192.png" alt="{{ app.appName }}" />
    </div>

    <div class="app-bootstrap-text">
      <strong>{{ app.appName }}</strong>
      <span>Iniciando sua sessão...</span>
    </div>
  </div>

  <div
    class="default-backdrop"
    *ngIf="pwa.showInstallBanner"
    (click)="dismissPwaBanner()"
  ></div>

  <div
    class="default-backdrop"
    *ngIf="pwa.showUpdateBanner"
    (click)="dismissUpdateBanner()"
  ></div>

  <ion-card *ngIf="pwa.showInstallBanner" class="default-banner">
    <ion-card-header class="banner-header">
      <ion-icon
        [name]="pwa.isIosInstall ? 'share-outline' : 'phone-portrait-outline'"
      ></ion-icon>

      <ion-card-title class="ion-text-center">
        {{
          pwa.isIosInstall
            ? 'Instale o app no seu iPhone'
            : 'Aproveite ao máximo o app ' + app.appName + '!'
        }}
      </ion-card-title>
    </ion-card-header>

    <ion-card-content class="banner-content">
      <ng-container *ngIf="pwa.isIosInstall; else installPrompt">
        Abra este site no Safari e adicione o {{ app.appName }} à Tela de
        Início para usar como aplicativo.

        <ol class="ios-install-steps">
          <li>Toque em <strong>Compartilhar</strong>.</li>
          <li>Escolha <strong>Adicionar à Tela de Início</strong>.</li>
          <li>Confirme em <strong>Adicionar</strong>.</li>
        </ol>

        <ion-button expand="block" (click)="dismissPwaBanner()" color="success">
          Entendi
        </ion-button>
      </ng-container>

      <ng-template #installPrompt>
        Tenha acesso rápido e use nosso app diretamente da sua tela inicial.

        <ion-button expand="block" (click)="installPWA()" color="success">
          Instalar agora
        </ion-button>
      </ng-template>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="pwa.showUpdateBanner" class="default-banner">
    <ion-card-header class="banner-header">
      <ion-icon name="settings-outline"></ion-icon>

      <ion-card-title class="ion-text-center">
        Uma nova atualização está disponível!
      </ion-card-title>
    </ion-card-header>

    <ion-card-content class="banner-content">
      Uma nova versão do app {{ app.appName }} foi lançada. Atualize para
      aproveitar as últimas melhorias e correções.

      <ion-button expand="block" (click)="updateApp()" color="success">
        Atualizar agora
      </ion-button>
    </ion-card-content>
  </ion-card>

  <ng-container *ngIf="app.isSandbox">
    <ion-chip id="sandbox-chip" color="dark" class="chip-sandbox">
      <ion-icon name="terminal-outline"></ion-icon>
    </ion-chip>

    <ion-popover trigger="sandbox-chip" triggerAction="click" side="bottom">
      <ng-template>
        <ion-content class="ion-padding"> Ambiente Sandbox </ion-content>
      </ng-template>
    </ion-popover>
  </ng-container>

  <ng-container *ngIf="!app.isSandbox && pwa.showInstallButton">
    <ion-chip
      id="install-chip"
      color="dark"
      class="chip-sandbox"
      (click)="installPWA()"
    >
      <ion-icon name="logo-pwa"></ion-icon>
    </ion-chip>

    <ion-popover
      trigger="install-chip"
      triggerAction="context-menu"
      side="bottom"
    >
      <ng-template>
        <ion-content class="ion-padding"> Instalar PWA </ion-content>
      </ng-template>
    </ion-popover>
  </ng-container>

  <ion-router-outlet></ion-router-outlet>

  <app-system-refresh-countdown></app-system-refresh-countdown>
  <app-cookie-consent></app-cookie-consent>

  @defer (when (paymentGate.addressGateOpen$ | async)) {
    <app-no-address-modal
      [isOpen]="!!(paymentGate.addressGateOpen$ | async)"
      [autoNavigate]="false"
      (confirmed)="paymentGate.onAddressConfirmed()"
      (closed)="paymentGate.onAddressDismissed()"
    ></app-no-address-modal>
  }

  @defer (when (paymentGate.addressFormGateOpen$ | async)) {
    <app-complete-address-modal
      [isOpen]="!!(paymentGate.addressFormGateOpen$ | async)"
      [dismissible]="true"
      (completed)="paymentGate.onAddressFormCompleted()"
      (closed)="paymentGate.onAddressFormDismissed()"
    ></app-complete-address-modal>
  }

  @defer (when (paymentGate.profileGateOpen$ | async)) {
    <app-complete-profile-modal
      [isOpen]="!!(paymentGate.profileGateOpen$ | async)"
      [dismissible]="true"
      (completed)="paymentGate.onProfileCompleted()"
      (closed)="paymentGate.onProfileClosed()"
    ></app-complete-profile-modal>
  }
</ion-app>
